// This entrypoint is deprecated. It will be removed as part of
// https://github.com/trailbehind/map2/issues/247

import FolderUI from '@gaia/components/folder-ui/FolderUI';
import ReactDOM from 'react-dom';

/**
 * Initialize FolderUI with options. Also creates a Dropdown tooltip instance
 * for displaying object options. Mode defaults to 'browse'. Set mode to 'choose'
 * to display a 'select' button instead of the dropdown.
 *
 * Right now, there can only be one 'browse' instance on a page at a time, since
 * it relies on the history API for navigation.
 *
 * @param  {Object}   options
 * @param  {String}   options.mode - 'browse' or 'choose'
 * @param  {String}   options.selector - Document selector to render FolderUI to.
 * @param  {Object}   options.objects - Hashmap of objects.
 * @param  {Array<String>} options.path - Array of object ids. Empty array is toplevel.
 * @param  {Boolean}  options.own - Is folder user's own folder?
 * @param  {String}   options.toplevel - String to display at top level.
 * @param  {Object}   options.topFolders - Hashmap of folder objects used in the move dialog.
 * @param  {String}   options.limit - Limit displayed objects to this type.
 * @param  {Function} options.fetchChildren - (id, callback) => {}
 *
 * // Limited to mode='browse'
 * @param  {Function} options.onNavigate - (id, type, path, isTop) => {}
 * @param  {Function} options.onRename - (id, type, name) => {}
 * @param  {Function} options.onMove - (id, type, sync) => {}
 * @param  {Function} options.onRemove - (id, type) => {}
 * @param  {Function} options.onSync - (id, type, sync) => {}
 * @param  {Function} options.onPublic - (id, type, permissions) => {}
 *
 * // Limited to mode='choose'
 * @param  {Function} options.onChoose - (id, type, target) => {}
 */

declare global {
    interface Window {
        FolderUI: {
            initialize: (options: Options) => void;
        };
    }
}

// Educated guess based on above and `controllers/DataDetailController.js`
interface Options {
    objects: Record<string, FolderSummary>; // FolderSummary may be incorrect
    path: string[];
    own: boolean;
    selector: string;
    toplevel: string;
    topFolders: Record<string, unknown>[];
    onNavigate: (id: string, type: string, path: string[], isTop: boolean) => void;
    onRename: (id: string, type: string, name: string) => void;
    onMove: (id: string, type: string, target: string) => void;
    onRemove: (id: string, type: string) => void;
    onSync: (id: string, type: string, sync: boolean) => void;
    onPublic: (id: string, type: string, permissions: boolean) => void;
    fetchChildren: (
        id: string,
        callback: (objects: Record<string, any>, children: string[]) => void
    ) => void;

    // following props not passed by DataDetailController ????
    mode: 'choose' | 'browse'; // not present in / never passed by JS call to this function????
    limit: string; // from FolderUI.jsx
    onChoose: (id: string, type: string) => void;
}

window.FolderUI = {
    initialize(options) {
        const mode = options.mode || 'browse';

        ReactDOM.render(
            <FolderUI
                mode={mode}
                objects={options.objects}
                topFolders={options.topFolders}
                path={options.path}
                own={options.own}
                toplevel={options.toplevel}
                limit={options.limit}
                fetchChildren={options.fetchChildren}
                onNavigate={options.onNavigate}
                onRename={options.onRename}
                onMove={options.onMove}
                onRemove={options.onRemove}
                onSync={options.onSync}
                onPublic={options.onPublic}
                onChoose={options.onChoose}
            />,
            document.querySelector(options.selector)
        );
    },
};
